<template>
    <el-dialog
        width="50%"
        title="操作日志"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="handleClose"
        class="configurationLogDialog">

        <div class="log-dialog-table">
            <el-table :data="tableData" border style="width: 100%" v-loading="loading" resizable="true" show-overflow-tooltip="true" height="400">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="operationName" label="操作类型" width="200" align="center"></el-table-column>
                <el-table-column prop="operationContent" label="操作内容" width="300" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="operatorName" label="操作人" width="130" align="center"></el-table-column>
                <el-table-column prop="createTime" label="操作时间" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </div>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="query.pageNo"
            :page-size="query.pageSize"
            :page-sizes="[10, 20, 30, 50]"
            layout="total, sizes, prev, pager, next"
            :total="countData">
        </el-pagination>
    </el-dialog>
</template>
<script>
import { getLogTotalData, getLogDataList } from '../../../../../api/transferSystem.js';
export default {
    name: 'operationLogDialog',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            countData: 0,
            tableData: [],
            loading: false,
            query: {
                pageNo: 1,
                pageSize: 10,
                orderBy: '',
                orderByType: 'desc'
            },
            logDialogDicList: [ '承运商转货站', '货站转货站','扫码转单','承运商指派末端司机','货站指派末端司机', '承运商撤回', '货站撤回' ]
        };
    },
    mounted () {
        this.initLogInfo();
    },
    methods: {
        // 初始化表单数据
        initLogInfo () {
            this.getListData();
            this.getTotalData();
        },
        // 获取列表数据
        getListData () {
            const params = {
                ...this.query,
                param: {
                    customerOrderNo: this.rowData.customerOrderNo,
                    dispatchNo: this.rowData.dispatchNo,
                    taskNo: this.rowData.taskNo
                }
            };
            getLogDataList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data.list || [];
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                })
        },
        // 获取列表数据条数
        getTotalData () {
            const params = {
                customerOrderNo: this.rowData.customerOrderNo,
                dispatchNo: this.rowData.dispatchNo,
                taskNo: this.rowData.taskNo
            };
            getLogTotalData(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.countData = res.data || 0;
                    }
                })
                .catch(() => { });
        },
        // 处理接口返回的数据
        formatLogTableData (list) {
            list.forEach(item => {
                // 将后端返回的 key 数据，转换为 value数据
                item.opeTypeName = this.logDialogDicList[item.opeType - 1];
                switch (item.opeType) {
                    case 1: item.action = `${item.stationName} 转 ${item.targetStationName}`
                    break;
                    case 2: item.action = `${item.stationName} 转 ${item.targetStationName}`
                    break;
                    case 3: item.action = `${item.stationName} 扫码转单 ${item.targetStationName}`
                    break;
                    case 4: item.action = `${item.stationName} 指派末端司机 ${item.driver} 电话：${item.driverContactWay}`
                    break;
                    case 5: item.action = `${item.stationName} 指派末端司机 ${item.driver} 电话：${item.driverContactWay}`
                    break;
                    case 6: item.action = `${item.stationName} 撤回`
                    break;
                    case 7: item.action = `${item.stationName} 撤回`
                    break;
                }
            })
            return list;
        },
        // 切换页面数据条数
        handleSizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.initLogInfo();
        },
        // 切换分页
        handleCurrentChange (pageNo) {
            this.query.pageNo = pageNo;
            this.initLogInfo();
        },
        // 关闭当前弹窗
        handleClose () {
            this.$emit('handleClose','logDialogVisible');
        }
    }
};
</script>
<style lang="less" scoped>
.configurationLogDialog {
    .log-dialog-table {
        min-height: 200px;
        max-height: 500px;
        overflow: auto;
    }
    .el-dialog__body {
        margin: 15px 15px;
    }
    .el-table {
        margin-bottom: 35px;
        min-height: 150px;
    }
    .el-pagination, .el-button {
        font-weight: normal;
        text-align: right;
    }
    .el-pagination .el-select .el-input{
        width: 70px;
    }
}
</style>
